import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

const UGCAgenturHamburg = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/?lang=de");
    }, 100);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>UGC Agentur Hamburg | AI UGC Creator Hamburg | Fuel72</title>
        <meta
          name="description"
          content="UGC Agentur Hamburg: Professionelle AI UGC Videos für Hamburger Unternehmen. UGC Creator Hamburg ohne Influencer. 72 Stunden Lieferung. ✓ Hansestadt-Qualität"
        />
        <meta
          name="keywords"
          content="ugc agentur hamburg, ugc creator hamburg, ugc hamburg, ai ugc hamburg, ugc videos hamburg, content creator hamburg, ugc werbung hamburg"
        />
        <link rel="canonical" href="https://www.fuel72.com/ugc-agentur-hamburg" />
        
        {/* Hreflang */}
        <link rel="alternate" hrefLang="de" href="https://www.fuel72.com/ugc-agentur-hamburg" />
        <link rel="alternate" hrefLang="de-DE" href="https://www.fuel72.com/ugc-agentur-hamburg" />
        <link rel="alternate" hrefLang="en" href="https://www.fuel72.com/hire-ugc" />
        
        {/* Open Graph */}
        <meta property="og:title" content="UGC Agentur Hamburg | AI UGC Creator | Fuel72" />
        <meta property="og:description" content="UGC Videos für Hamburger Unternehmen. Hanseatische Qualität, moderne Technologie." />
        <meta property="og:url" content="https://www.fuel72.com/ugc-agentur-hamburg" />
        <meta property="og:locale" content="de_DE" />
        
        {/* Geo Tags */}
        <meta name="geo.region" content="DE-HH" />
        <meta name="geo.placename" content="Hamburg" />
        <meta name="geo.position" content="53.551086;9.993682" />
        <meta name="ICBM" content="53.551086, 9.993682" />

        {/* Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Fuel72 - UGC Agentur Hamburg",
            "description": "Professionelle AI UGC Videos für Hamburger Unternehmen. Hanseatische Qualität trifft moderne AI-Technologie.",
            "url": "https://www.fuel72.com/ugc-agentur-hamburg",
            "telephone": "+4917687870011",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Hamburg",
              "addressRegion": "Hamburg",
              "addressCountry": "DE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "53.551086",
              "longitude": "9.993682"
            },
            "areaServed": {
              "@type": "City",
              "name": "Hamburg"
            },
            "priceRange": "€€"
          })}
        </script>
      </Helmet>

      <main className="min-h-screen gradient-mesh flex items-center justify-center">
        <div className="container mx-auto px-4 py-20 text-center">
          <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6">
            UGC Agentur{" "}
            <span className="bg-gradient-to-r from-neon-purple via-neon-pink to-orange-500 bg-clip-text text-transparent">
              Hamburg
            </span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
            Hanseatische Qualität trifft AI-Innovation. 
            UGC Videos für Hamburger Unternehmen.
          </p>
          
          <div className="max-w-3xl mx-auto text-left space-y-6">
            <h2 className="text-2xl font-bold">UGC für die Hansestadt</h2>
            <p className="text-muted-foreground">
              Hamburg ist Deutschlands Tor zur Welt und Heimat zahlreicher internationaler 
              Unternehmen. Mit Fuel72 erhalten Hamburger Businesses professionelle UGC Videos, 
              die global funktionieren – in nur 72 Stunden.
            </p>
            
            <h2 className="text-2xl font-bold mt-8">Branchen in Hamburg</h2>
            <ul className="space-y-2 text-muted-foreground">
              <li>⚓ Maritime & Logistik</li>
              <li>🏬 Handel & E-Commerce</li>
              <li>🎨 Werbeagenturen & Kreative</li>
              <li>☕ Gastronomie & Lifestyle</li>
              <li>🏢 Corporate & B2B</li>
            </ul>
            
            <h2 className="text-2xl font-bold mt-8">Von der Speicherstadt bis Blankenese</h2>
            <p className="text-muted-foreground">
              Ob HafenCity-Startup oder traditionelles Kaufmannshaus – Fuel72 liefert 
              maßgeschneiderte UGC Videos für jedes Hamburger Unternehmen. Moin!
            </p>
          </div>
          
          <p className="text-sm text-muted-foreground mt-12">Weiterleitung zur Hauptseite...</p>
        </div>
      </main>
    </>
  );
};

export default UGCAgenturHamburg;
